import React from 'react';
import { Dialog, DialogContent, DialogTitle, Typography, Divider, List, ListItem, ListItemText } from "@mui/material";
import IconButton from "@mui/material/IconButton";

function InfoSupplies({ isOpen, onClose }) {
    return (
        <Dialog open={isOpen} onClose={onClose} maxWidth="md" fullWidth>
            {/* Dialog Title */}
            <DialogTitle
                sx={{
                    color: '#151269',
                    textAlign: 'center',
                    backgroundColor: 'rgba(198, 226, 255, 0.8)',
                    paddingRight: '30px'
                }}
            >
                Supplies
            </DialogTitle>

            <DialogTitle
                sx={{
                    fontSize: '18px',
                    textAlign: 'center',
                    color: '#151269',
                    backgroundColor: 'rgba(198, 226, 255, 0.8)',
                    padding: 0
                }}
            >
                Create and manage packing lists tailored to your trips.
            </DialogTitle>

            {/* Close Button */}
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={{
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: '#151269',
                }}
            >
                <i className="icon-cross" style={{ fontSize: '18px', padding: '5px' }} />
            </IconButton>

            {/* Dialog Content */}
            <DialogContent>
                <List>
                    {/* All items */}
                    <ListItem>
                        <ListItemText
                            primary={
                                <span>
                                    <i className="icon-calendar3" title="Date and Time" style={{ fontSize: "18px", marginRight: "8px", color: "#1976d2" }} />
                                    Never Miss a Thing Again
                                </span>
                            }
                            secondary={
                                <Typography variant="body2">
                                    Our "Supplies" section is your secret weapon against last-minute scrambles.
                                    Think of it as your personal checklist guru, ensuring you've got everything covered for a flawless event! ✅
                                </Typography>
                            }
                        />
                    </ListItem>
                    <Divider />

                    {/* Essentials */}
                    <ListItem>
                        <ListItemText
                            primary={
                                <span>
                                    <i className="icon-map-marker" title="Meal Location" style={{ fontSize: "18px", marginRight: "8px", color: "#1976d2" }} />
                                    Essentials at Your Fingertips
                                </span>
                            }
                            secondary={
                                <Typography variant="body2">
                                    With our handy "Essentials" feature, you can create and reuse supply lists for every new event.
                                    No more reinventing the wheel – just grab your go-to gear and go! ⚙️
                                </Typography>
                            }
                        />
                    </ListItem>
                    <Divider />

                    {/* Privacy */}
                    <ListItem>
                        <ListItemText
                            primary={
                                <span>
                                    <i className="icon-user-24" title="Attendees" style={{ fontSize: "18px", marginRight: "8px", color: "#1976d2" }} />
                                    Keep it Under Wraps (If You Want!)
                                </span>
                            }
                            secondary={
                                <Typography variant="body2">
                                    Need to brainstorm in secret? Our privacy mode lets you keep your supply list visible only to your eyes.
                                    Perfect for those surprise elements! 🤫
                                </Typography>
                            }
                        />
                    </ListItem>
                    <Divider />

                </List>
            </DialogContent>
        </Dialog>
    );
}

export default InfoSupplies;
